import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { Close } from '../toolset/assets/icons';
import { black } from '../../../../../styling/theme';
import DateSelection from '../inputComponents/DatePicker/date2';
import { SelectComponent } from './crossrefUtilities';
import AddField from '../UI/addField';
import getToken from '../../../../../utility/getToken';
import RemoveField from '../UI/removeField';
import wiseRefController from '../../../../../utility/wiseRefController';
import journalTypes from '../../../../../constants/templateDictionaries/journalTypes';
import {
  SmallInputContainer,
  SmallInput1,
  SmallInput2,
  Container,
  InputContainer,
  HeadingContainer,
  Smart,
  CloseOuter,
  Input,
  ErrorMessage,
  Authors,
  AdvanceContainer,
  AdvancedButton,
} from '../UI/referenceStyles/manualWrapper';

const textFields = [
  { field: 'title', title: 'Title *', note: 'Madatory Field!' },
  {
    field: 'container-title',
    title: 'Container Title',
    note: 'Title of journal, conference, ... etc!',
  },
  { field: 'issued', title: 'Publication Date', type: 'date' },
  { field: 'publisher', title: 'Publisher' },
  { field: 'volume', title: 'Volume' },
  { field: 'issue', title: 'Issue' },
  { field: 'DOI', title: 'DOI' },
  { field: 'ISSN', title: 'ISSN', note: 'Format xxxx-xxxx' },
  { field: 'ISBN', title: 'ISBN' },
  { field: 'URL', title: 'URL' },
  { field: 'from-Page', title: 'Start Page' },
  { field: 'to-Page', title: 'End Page' },
];

const initialState = {
  type: '',
  title: '',
  'container-title': '',
  author: [],
  'from-Page': '',
  'to-Page': '',
  issued: '',
  ISSN: '',
  ISBN: '',
  DOI: '',
  publisher: '',
  volume: '',
  issue: '',
  URL: '',
  asStringMode: false,
  refAsString: '',
  invalidForm: false,
  submit: false,
};

export default class ManualAddReference2 extends Component {
  state = {
    ...initialState,
    author: [
      {
        title: 'author',
        given: '',
        family: '',
        affiliation: '',
        key: uuidv4(),
      },
    ],
  };

  notEmptyField = (value) => {
    if (typeof value === 'object') {
      return value.toISOString().substring(0, 10).trim() !== '';
    }
    return value.trim() !== '';
  };

  clearForm = () => {
    this.setState({
      ...initialState,
      author: [
        {
          title: 'author',
          given: '',
          family: '',
          affiliation: '',
          key: uuidv4(),
        },
      ],
    });
  };

  validAuthor = (c) =>
    c.given.trim() || c.family.trim() || c.affiliation.trim();

  trimAuthor = (a) => ({
    given: a.given.trim(),
    family: a.family.trim(),
    affiliation: a.affiliation.trim(),
  });

  generateJSON = () => {
    const specialFields = ['to-Page', 'from-Page', 'issued'];
    const { 'to-Page': toPage, 'from-Page': fromPage, issued } = this.state;
    const curState = { ...this.state };
    const cslJSON = {};
    textFields
      .filter(
        (item) =>
          !(item.field in specialFields) &&
          this.notEmptyField(curState[item.field]),
      )
      .forEach((item) => {
        if (typeof curState[item.field] === 'object') {
          cslJSON[item.field] = curState[item.field]
            .toISOString()
            .substring(0, 10)
            .trim();
          return;
        }
        cslJSON[item.field] = curState[item.field].trim();
      });
    const issuedNotEmpty = this.notEmptyField(issued);
    if (issuedNotEmpty) {
      const d = new Date(issued);
      cslJSON.issued = {
        'date-parts': [
          [`${d.getFullYear()}`, `${d.getMonth() + 1}`, `${d.getDate()}`],
        ],
      };
    }
    const FromPageNotEmpty = this.notEmptyField(fromPage);
    const ToPageNotEmpty = this.notEmptyField(toPage);

    if (FromPageNotEmpty && ToPageNotEmpty) {
      cslJSON.page = `${fromPage.trim()}-${toPage.trim()}`;
    } else if (FromPageNotEmpty || ToPageNotEmpty) {
      cslJSON.page = `${fromPage.trim()}${toPage.trim()}`;
    }
    cslJSON.author = [];
    const { author } = this.state;
    // As per CSLJSON format authors property is called 'author' in their standard.
    author.forEach(
      (oneAuthor) =>
        this.validAuthor(oneAuthor) &&
        cslJSON.author.push(this.trimAuthor(oneAuthor)),
    );
    cslJSON.title = [cslJSON.title];
    cslJSON.id = 'xxxx';
    return cslJSON;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { title, issued } = this.state;
    if (typeof title !== 'string' || title === '' || issued === '') {
      this.setState({ invalidForm: true });
    } else {
      this.setState({ submit: true });
      const { handleUpdateReference, closeModal } = this.props;
      const cslJSON = this.generateJSON();
      const token = await getToken();
      const respondJSON = await wiseRefController.styledReferences(
        {
          references: { items: [cslJSON] },
          style: journalTypes.APA.refStyle,
          locale: journalTypes.APA.refLocale,
          isPDF: true,
        },
        token,
      );
      const parsedResponse = JSON.parse(respondJSON.data);
      handleUpdateReference(
        parsedResponse[1].length === 0
          ? ''
          : parsedResponse[1][0].slice(0, parsedResponse[1][0].length - 1),
      );
      closeModal();
    }
  };

  addAuthor = (e, index) => {
    e.preventDefault();

    const { author } = this.state;
    const curAuthorArray = [...author];
    curAuthorArray.splice(index + 1, 0, {
      title: 'author',
      given: '',
      family: '',
      affiliation: '',
      key: uuidv4(),
    });
    this.setState({
      author: curAuthorArray,
    });
  };

  removeAuthor = (e, index) => {
    e.preventDefault();
    const { author } = this.state;
    if (author.length > 1) {
      const curAuthorArray = [...author];
      curAuthorArray.splice(index, 1);
      this.setState({
        author: curAuthorArray,
      });
    }
  };

  handleChangeAuthor = (index, field, event) => {
    const { author } = this.state;
    author[index][field] = event.target.value;
    this.setState({ author });
  };

  author = () => {
    const { author } = this.state;
    const authorsLength = author.length;
    return (
      <Authors>
        {author.map((oneAuthor, index) => (
          <SmallInputContainer key={oneAuthor.key} bottom left right="4px">
            <SmallInput1
              onKeyDown={this.keyDown}
              value={oneAuthor.given}
              type="text"
              placeholder="Author first name"
              onChange={(e) => this.handleChangeAuthor(index, 'given', e)}
            />
            <SmallInput2
              onKeyDown={this.keyDown}
              value={oneAuthor.family}
              type="text"
              placeholder="Author middle name"
              onChange={(e) => this.handleChangeAuthor(index, 'family', e)}
            />
            <SmallInput2
              onKeyDown={this.keyDown}
              value={oneAuthor.affiliation}
              type="text"
              placeholder="Author last name"
              onChange={(e) => this.handleChangeAuthor(index, 'affiliation', e)}
            />
            <AddField clickHandle={(e) => this.addAuthor(e, index)} />
            <RemoveField
              authorsLength={authorsLength}
              clickHandle={(e) => this.removeAuthor(e, index)}
            />
          </SmallInputContainer>
        ))}
      </Authors>
    );
  };

  handleFormChange = (field, value) => {
    this.setState({ [field]: value });
  };

  keyDown = (event) => {
    event.stopPropagation();
  };

  render() {
    const curState = { ...this.state };
    const { closeModal } = this.props;

    return (
      <Container>
        <HeadingContainer>
          <Smart>MANUAL</Smart>
          <CloseOuter onClick={closeModal}>
            <Close fill={black} height="18px" width="18px" />
          </CloseOuter>
        </HeadingContainer>
        <InputContainer>
          <Input
            onKeyDown={this.keyDown}
            onChange={({ target: { value } }) =>
              this.handleFormChange('title', value)
            }
            value={curState.title}
            type="text"
            placeholder="Title of Publication"
            data-testid="title"
          />
        </InputContainer>
        {curState.invalidForm && !curState.title && (
          <ErrorMessage noResults data-testid="error-title">
            Madatory Field!
          </ErrorMessage>
        )}
        {this.author()}
        <InputContainer top="8px">
          <Input
            onKeyDown={this.keyDown}
            onChange={({ target: { value } }) =>
              this.handleFormChange('container-title', value)
            }
            value={curState['container-title']}
            type="text"
            placeholder="Title of journal, conference, ...etc"
          />
        </InputContainer>
        <SmallInputContainer>
          {SelectComponent(
            curState.type,
            'type',
            this.handleFormChange,
            '110%',
          )}
          <DateSelection
            width="100%"
            marginLeft="8px"
            date={curState.issued}
            handleChange={(date) => this.handleFormChange('issued', date)}
            placeholderText="Publication Date (Mandatory)"
          />
          <SmallInput2
            onKeyDown={this.keyDown}
            type="text"
            placeholder="Publisher"
            onChange={({ target: { value } }) =>
              this.handleFormChange('publisher', value)
            }
            value={curState.publisher}
          />
        </SmallInputContainer>
        {curState.invalidForm && !curState.issued && (
          <ErrorMessage noResults data-testid="error-issued">
            Madatory Field!
          </ErrorMessage>
        )}
        <SmallInputContainer>
          <SmallInput1
            onKeyDown={this.keyDown}
            type="text"
            placeholder="Volume"
            onChange={({ target: { value } }) =>
              this.handleFormChange('volume', value)
            }
            value={curState.volume}
          />
          <SmallInput2
            onKeyDown={this.keyDown}
            type="text"
            placeholder="Issue"
            onChange={({ target: { value } }) =>
              this.handleFormChange('issue', value)
            }
            value={curState.issue}
          />
          <SmallInput2
            onKeyDown={this.keyDown}
            type="text"
            placeholder="DOI"
            onChange={({ target: { value } }) =>
              this.handleFormChange('DOI', value)
            }
            value={curState.DOI}
          />
        </SmallInputContainer>
        <SmallInputContainer>
          <SmallInput1
            onKeyDown={this.keyDown}
            type="text"
            placeholder="ISSN"
            onChange={({ target: { value } }) =>
              this.handleFormChange('ISSN', value)
            }
            value={curState.ISSN}
          />
          <SmallInput2
            onKeyDown={this.keyDown}
            type="text"
            placeholder="ISBN"
            onChange={({ target: { value } }) =>
              this.handleFormChange('ISBN', value)
            }
            value={curState.ISBN}
          />
          <SmallInput2
            onKeyDown={this.keyDown}
            type="text"
            placeholder="URL"
            onChange={({ target: { value } }) =>
              this.handleFormChange('URL', value)
            }
            value={curState.URL}
          />
        </SmallInputContainer>
        <SmallInputContainer right="226px">
          <SmallInput1
            onKeyDown={this.keyDown}
            type="text"
            placeholder="Start page"
            onChange={({ target: { value } }) =>
              this.handleFormChange('from-Page', value)
            }
            value={curState['from-Page']}
          />
          <SmallInput2
            onKeyDown={this.keyDown}
            type="text"
            placeholder="End page"
            onChange={({ target: { value } }) =>
              this.handleFormChange('to-Page', value)
            }
            value={curState['to-Page']}
          />
        </SmallInputContainer>
        <AdvanceContainer>
          <AdvancedButton
            data-testid="create"
            onClick={!curState.submit ? this.handleSubmit : () => {}}
            submit={!curState.submit}
          >
            Create
          </AdvancedButton>
          <AdvancedButton
            data-testid="reset"
            onClick={!curState.submit ? this.clearForm : () => {}}
            submit={!curState.submit}
          >
            Reset
          </AdvancedButton>
        </AdvanceContainer>
      </Container>
    );
  }
}

ManualAddReference2.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleUpdateReference: PropTypes.func.isRequired,
};
